import { render, staticRenderFns } from "./AIVRow.vue?vue&type=template&id=66d2a761&scoped=true"
import script from "./AIVRow.vue?vue&type=script&lang=js"
export * from "./AIVRow.vue?vue&type=script&lang=js"
import style0 from "./AIVRow.vue?vue&type=style&index=0&id=66d2a761&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d2a761",
  null
  
)

export default component.exports